// extracted by mini-css-extract-plugin
export default {"root":"DraggedNode_root__PVv7j","icon":"DraggedNode_icon__7HsSG","label":"DraggedNode_label__22Zo0"};